import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import axios from "axios";
import {
  AuditOutlined,
  CalendarOutlined,
  QuestionCircleOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import moment from "moment";
import _ from "lodash";
import * as XLSX from "xlsx";
import MerchantReading from "../../../merchant/report/report/MerchantReading";
import MerchantEmployeeReportOrderDetails from "../../team-leader/reports/MerchantEmployeeReportOrderDetails";
import MerchantEmployeeLayout from "../../../layout/MerchantEmployeeLayout";
import MerchantReportPerProduct from "../../../merchant/report/report/MerchantReportPerProduct";
import {
  NotificationInfo,
  PermissionInfo,
  UserInfo,
} from "../../../../context";

const MerchantEmployeeAccountingReports = () => {
  const [dataList, setDataList] = useState({
    data: [],
    ready: false,
  });
  const [merchantOrderSaveList, setMerchantOrderSaveList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const { permissionList } = useContext(PermissionInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [totalGross, setTotalGross] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalCostPerProd, setTotalCostPerProd] = useState(0);

  const [totalDineIn, setTotalDineIn] = useState(0);
  const [totalTakeOut, setTotalTakeOut] = useState(0);
  const [totalPickup, setTotalPickup] = useState(0);
  const [totalDelivery, setTotalDelivery] = useState(0);
  const [totalCash, setTotalCash] = useState(0);
  const [totalECash, setTotalECash] = useState(0);

  //new
  const [totalGCash, setTotalGCash] = useState(0);
  const [totalGCredit, setTotalGCredit] = useState(0);
  const [totalPaymaya, setTotalPaymaya] = useState(0);
  const [totalCreditCard, setTotalCreditCard] = useState(0);
  const [totalDebitCard, setTotalDebitCard] = useState(0);
  const [totalBankTransfer, setTotalBankTransfer] = useState(0);
  const [totalCheque, setTotalCheque] = useState(0);

  const [loading, setLoading] = useState(false);
  const [openFilterByDate, setOpenFilterByDate] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [search, setSearch] = useState("");
  const [detectFilter, setDetectFilter] = useState(false);
  const [openReaderDrawer, setOpenReaderDrawer] = useState(false);
  const [openPerProdDrawer, setOpenPerProdDrawer] = useState(false);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [employeeList, setEmployeeList] = useState({
    data: [],
    ready: false,
  });

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "",
      render: (text) => (
        <div
          style={{
            width: 10,
            height: 10,
            backgroundColor: parseFloat(text.discount) !== 0 ? "red" : "green",
            marginRight: 5,
          }}
        />
      ),
    },
    {
      title: "Transaction Date",
      dataIndex: "created_at",
      render: (date) => (
        <p>{moment.utc(new Date(date)).format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Transaction Number",
      dataIndex: "transaction_id",
      sorter: (a, b) => a.transaction_id - b.transaction_id,
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Location",
      dataIndex: "table_no",
      render: (text, record) => <p>{text !== "Table #" ? text : ""}</p>,
    },
    {
      title: "Cashiered By",
      dataIndex: "cashiered_by",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Status",
      dataIndex: "service_category",
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            color:
              text === "dine"
                ? "green"
                : text === "pickup"
                ? "#aeaeae"
                : text === "delivery"
                ? "#b804c2"
                : "blue",
            fontWeight: "bold",
          }}
        >
          {text === "dine"
            ? "DINE"
            : text === "pickup"
            ? "PICK UP"
            : text === "delivery"
            ? "DELIVERY"
            : "TAKE OUT"}
        </p>
      ),
    },
    {
      title: "Cost",
      dataIndex: "cost",
      align: "center",
      render: (text, record) => (
        <p style={{ textAlign: "right" }}>
          {text.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 40,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 40 }}>
          <Tooltip title="Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantOrderSaveList = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
      status: 1,
      orderby: "desc",
      order_category: "all",
      date_from: moment().subtract(6, "days").format("YYYY-MM-DD"),
      date_to: moment().format("YYYY-MM-DD"),
    };
    axios
      .get("user/merchant/report-customer-order-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        const perprod = _.chain(data)
          .groupBy((g) => g.product_id)
          .map((value, key) => ({
            product_id: key,
            product: value[0].product,
            total: getPerProdTotal(value),
            per_piece: parseInt(value[0].is_per_piece) === 1 ? true : false,
            order_category: value[0].order_category,
            product_category:
              value[0].customerorderroductinfo !== null
                ? value[0].customerorderroductinfo.productcategory.category
                : null,
          }))
          .value();
        setDataList({ data: perprod, ready: true });
        const res = _.chain(data)
          .groupBy((g) => g.transaction_id)
          .map((value, key) => ({
            transaction_id: key,
            data: _.orderBy(value, ["id"], ["asc"]),
            customer_name: value[0].customer_name,
            created_at: value[0].created_at,
            table_no: value[0].table_no,
            service_category: value[0].service_category,
            cashiered_by:
              value[0].customerordercashiered !== null
                ? value[0].customerordercashiered.firstname
                : "",
            cost: getTotalCost(value),
            cost_per_prod: getTotalCostPerProd(
              _.orderBy(value, ["id"], ["asc"])
            ),
            discount: getTotalDiscount(value),
            dine_in: getTotalDineIn(value),
            take_out: getTotalTakeOut(value),
            pick_up: getTotalPickup(value),
            delivery: getTotalDelivery(value),
            cash: getTotalCash(value),
            ecash: getTotalECash(value),

            gcash: getTotalNonCash("gcash", value),
            gcredit: getTotalNonCash("gcredit", value),
            paymaya: getTotalNonCash("paymaya", value),
            creditcard: getTotalNonCash("creditcard", value),
            debitcard: getTotalNonCash("debitcard", value),
            banktransfer: getTotalNonCash("banktransfer", value),
            cheque: getTotalNonCash("cheque", value),
          }))
          .value();
        const res2 = _.orderBy(res, ["created_at"], ["desc"]);
        // console.log("RES2: ", res2);

        setMerchantOrderSaveList({ data: res2, ready: true });
        setTotalGross(calculateTotal(res, "gross"));
        setTotalDiscount(calculateTotal(res, "discount"));
        setTotalCostPerProd(calculateTotal(res, "cost_per_prod"));

        setTotalDineIn(calculateTotal(res, "dinein"));
        setTotalTakeOut(calculateTotal(res, "takeout"));
        setTotalPickup(calculateTotal(res, "pickup"));
        setTotalDelivery(calculateTotal(res, "delivery"));
        setTotalCash(calculateTotal(res, "cash"));
        setTotalECash(calculateTotal(res, "ecash"));

        setTotalGCash(calculateTotal(res, "gcash"));
        setTotalGCredit(calculateTotal(res, "gcredit"));
        setTotalPaymaya(calculateTotal(res, "paymaya"));
        setTotalCreditCard(calculateTotal(res, "creditcard"));
        setTotalDebitCard(calculateTotal(res, "debitcard"));
        setTotalBankTransfer(calculateTotal(res, "banktransfer"));
        setTotalCheque(calculateTotal(res, "cheque"));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  const getPerProdTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseInt(data[i].quantity) * 1;
    }
    return total;
  };

  const getTotalCost = (data) => {
    var total = 0;
    var newData = data.slice().sort(function (a, b) {
      return a.id - b.id;
    });

    // console.log("newData", newData[0]);
    if (
      newData[0].order_category === "additional-service" &&
      newData[0].service_type === "consumable"
    ) {
      const res = _.chain(newData)
        .groupBy((g) => g.order_category)
        .map((value, key) => ({
          order_category: key,
          data: value,
          total: totalConsumption(value),
          discount: discountConsumption(value),
          per_product: totalCostPerProduct(value),
        }))
        .value();
      res.length > 1
        ? parseFloat(res[0].total + res[0].per_product - res[0].discount) >
          parseFloat(res[1].total + res[1].per_product - res[1].discount)
          ? (total = res[0].total + res[0].per_product - res[0].discount)
          : (total = res[1].total + res[1].per_product - res[1].discount)
        : (total = res[0].total + res[0].per_product - res[0].discount);
    } else {
      for (let i = 0; i < data.length; i++) {
        total +=
          (parseInt(data[i].is_per_piece) === 1
            ? (data[i].quantity !== null ? parseInt(data[i].quantity) : 1) *
              parseFloat(data[i].price.replace(",", ""))
            : parseFloat(data[i].price.replace(",", ""))) +
          parseFloat(
            data[i].cost_per_prod !== null
              ? parseInt(data[i].is_per_piece) === 0
                ? data[i].cost_per_prod
                : data[i].cost_per_prod * data[i].quantity
              : 0
          ) -
          parseFloat(data[i].discount_amount);
      }
    }

    return total;
  };

  const getTotalDiscount = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseFloat(data[i].discount_amount);
    }
    return total;
  };

  const getTotalCostPerProd = (data) => {
    var total = 0;
    if (
      data[0].service_type === "consumable" &&
      data[0].order_category === "additional-service"
    ) {
      const res = _.chain(data)
        .groupBy((g) => g.order_category)
        .map((value, key) => ({
          order_category: key,
          data: value,
          total: totalConsumption(value),
          discount: discountConsumption(value),
          per_product: totalCostPerProduct(value),
        }))
        .value();
      res.length > 1
        ? parseFloat(res[0].total + res[0].per_product - res[0].discount) >
          parseFloat(res[1].total + res[1].per_product - res[1].discount)
          ? (total = res[0].per_product)
          : (total = res[1].per_product)
        : (total = res[0].per_product);
      // console.log("TOTAL: ", total);
      return total;
    } else {
      for (let i = 0; i < data.length; i++) {
        total += parseFloat(
          data[i].cost_per_prod !== null
            ? parseInt(data[i].is_per_piece) === 0
              ? data[i].cost_per_prod
              : data[i].cost_per_prod * data[i].quantity
            : 0
        );
      }
      // console.log("TOTAL: ", total);

      return total;
    }
  };

  const getTotalDineIn = (data) => {
    var total = 0;
    var newData = data.slice().sort(function (a, b) {
      return a.id - b.id;
    });
    if (
      newData[0].order_category === "additional-service" &&
      newData[0].service_type === "consumable" &&
      newData[0].service_category === "dine"
    ) {
      const res = _.chain(newData)
        .groupBy((g) => g.order_category)
        .map((value, key) => ({
          order_category: key,
          data: value,
          total: totalConsumption(value),
          discount: discountConsumption(value),
          per_product: totalCostPerProduct(value),
        }))
        .value();
      res.length > 1
        ? parseFloat(res[0].total + res[0].per_product - res[0].discount) >
          parseFloat(res[1].total + res[1].per_product - res[1].discount)
          ? (total = res[0].total + res[0].per_product - res[0].discount)
          : (total = res[1].total + res[1].per_product - res[1].discount)
        : (total = res[0].total + res[0].per_product - res[0].discount);
    } else {
      for (let i = 0; i < data.length; i++) {
        if (data[i].service_category === "dine") {
          total +=
            (parseInt(data[i].is_per_piece) === 1
              ? (data[i].quantity !== null ? parseInt(data[i].quantity) : 1) *
                parseFloat(data[i].price)
              : parseFloat(data[i].price) * 1) +
            parseFloat(
              data[i].cost_per_prod !== null
                ? parseInt(data[i].is_per_piece) === 0
                  ? data[i].cost_per_prod
                  : data[i].cost_per_prod * data[i].quantity
                : 0
            ) -
            parseFloat(data[i].discount_amount);
        }
      }
    }

    return total;
  };

  const getTotalTakeOut = (data) => {
    var total = 0;
    var newData = data.slice().sort(function (a, b) {
      return a.id - b.id;
    });
    if (
      newData[0].order_category === "additional-service" &&
      newData[0].service_type === "consumable" &&
      newData[0].service_category === "takeout"
    ) {
      const res = _.chain(newData)
        .groupBy((g) => g.order_category)
        .map((value, key) => ({
          order_category: key,
          data: value,
          total: totalConsumption(value),
          discount: discountConsumption(value),
          per_product: totalCostPerProduct(value),
        }))
        .value();
      res.length > 1
        ? parseFloat(res[0].total + res[0].per_product - res[0].discount) >
          parseFloat(res[1].total + res[1].per_product - res[1].discount)
          ? (total = res[0].total + res[0].per_product - res[0].discount)
          : (total = res[1].total + res[1].per_product - res[1].discount)
        : (total = res[0].total + res[0].per_product - res[0].discount);
    } else {
      for (let i = 0; i < data.length; i++) {
        if (data[i].service_category === "takeout") {
          total +=
            (parseInt(data[i].is_per_piece) === 1
              ? (data[i].quantity !== null ? parseInt(data[i].quantity) : 1) *
                parseFloat(data[i].price)
              : parseFloat(data[i].price) * 1) +
            parseFloat(
              data[i].cost_per_prod !== null
                ? parseInt(data[i].is_per_piece) === 0
                  ? data[i].cost_per_prod
                  : data[i].cost_per_prod * data[i].quantity
                : 0
            ) -
            parseFloat(data[i].discount_amount);
        }
      }
    }

    return total;
  };

  const getTotalPickup = (data) => {
    var total = 0;
    var newData = data.slice().sort(function (a, b) {
      return a.id - b.id;
    });
    if (
      newData[0].order_category === "additional-service" &&
      newData[0].service_type === "consumable" &&
      newData[0].service_category === "pickup"
    ) {
      const res = _.chain(newData)
        .groupBy((g) => g.order_category)
        .map((value, key) => ({
          order_category: key,
          data: value,
          total: totalConsumption(value),
          discount: discountConsumption(value),
          per_product: totalCostPerProduct(value),
        }))
        .value();
      res.length > 1
        ? parseFloat(res[0].total + res[0].per_product - res[0].discount) >
          parseFloat(res[1].total + res[1].per_product - res[1].discount)
          ? (total = res[0].total + res[0].per_product - res[0].discount)
          : (total = res[1].total + res[1].per_product - res[1].discount)
        : (total = res[0].total + res[0].per_product - res[0].discount);
    } else {
      for (let i = 0; i < data.length; i++) {
        if (data[i].service_category === "pickup") {
          total +=
            (parseInt(data[i].is_per_piece) === 1
              ? (data[i].quantity !== null ? parseInt(data[i].quantity) : 1) *
                parseFloat(data[i].price)
              : parseFloat(data[i].price) * 1) +
            parseFloat(
              data[i].cost_per_prod !== null
                ? parseInt(data[i].is_per_piece) === 0
                  ? data[i].cost_per_prod
                  : data[i].cost_per_prod * data[i].quantity
                : 0
            ) -
            parseFloat(data[i].discount_amount);
        }
      }
    }
    return total;
  };

  const getTotalDelivery = (data) => {
    var total = 0;
    var newData = data.slice().sort(function (a, b) {
      return a.id - b.id;
    });
    if (
      newData[0].order_category === "additional-service" &&
      newData[0].service_type === "consumable" &&
      newData[0].service_category === "delivery"
    ) {
      const res = _.chain(newData)
        .groupBy((g) => g.order_category)
        .map((value, key) => ({
          order_category: key,
          data: value,
          total: totalConsumption(value),
          discount: discountConsumption(value),
          per_product: totalCostPerProduct(value),
        }))
        .value();
      res.length > 1
        ? parseFloat(res[0].total + res[0].per_product - res[0].discount) >
          parseFloat(res[1].total + res[1].per_product - res[1].discount)
          ? (total = res[0].total + res[0].per_product - res[0].discount)
          : (total = res[1].total + res[1].per_product - res[1].discount)
        : (total = res[0].total + res[0].per_product - res[0].discount);
    } else {
      for (let i = 0; i < data.length; i++) {
        if (data[i].service_category === "delivery") {
          total +=
            (parseInt(data[i].is_per_piece) === 1
              ? (data[i].quantity !== null ? parseInt(data[i].quantity) : 1) *
                parseFloat(data[i].price)
              : parseFloat(data[i].price) * 1) +
            parseFloat(
              data[i].cost_per_prod !== null
                ? parseInt(data[i].is_per_piece) === 0
                  ? data[i].cost_per_prod
                  : data[i].cost_per_prod * data[i].quantity
                : 0
            ) -
            parseFloat(data[i].discount_amount);
        }
      }
    }
    return total;
  };

  const getTotalCash = (data) => {
    var total = 0;
    var newData = data.slice().sort(function (a, b) {
      return a.id - b.id;
    });
    if (
      newData[0].order_category === "additional-service" &&
      newData[0].service_type === "consumable" &&
      newData[0].payment_method === "cash"
    ) {
      const res = _.chain(newData)
        .groupBy((g) => g.order_category)
        .map((value, key) => ({
          order_category: key,
          data: value,
          total: totalConsumption(value),
          discount: discountConsumption(value),
          per_product: totalCostPerProduct(value),
        }))
        .value();
      res.length > 1
        ? parseFloat(res[0].total + res[0].per_product - res[0].discount) >
          parseFloat(res[1].total + res[1].per_product - res[1].discount)
          ? (total = res[0].total + res[0].per_product - res[0].discount)
          : (total = res[1].total + res[1].per_product - res[1].discount)
        : (total = res[0].total + res[0].per_product - res[0].discount);
    } else {
      for (let i = 0; i < data.length; i++) {
        if (data[i].payment_method === "cash") {
          total +=
            (parseInt(data[i].is_per_piece) === 1
              ? (data[i].quantity !== null ? parseInt(data[i].quantity) : 1) *
                parseFloat(data[i].price)
              : parseFloat(data[i].price) * 1) +
            parseFloat(
              data[i].cost_per_prod !== null
                ? parseInt(data[i].is_per_piece) === 0
                  ? data[i].cost_per_prod
                  : data[i].cost_per_prod * data[i].quantity
                : 0
            ) -
            parseFloat(data[i].discount_amount);
        }
        if (data[i].payment_method === "split-cash") {
          total = parseFloat(data[0].payment);
        }
      }
    }

    return total;
  };

  const getTotalECash = (data) => {
    var total = 0;
    var newData = data.slice().sort(function (a, b) {
      return a.id - b.id;
    });
    if (
      newData[0].order_category === "additional-service" &&
      newData[0].service_type === "consumable" &&
      newData[0].payment_method === "ecash"
    ) {
      const res = _.chain(newData)
        .groupBy((g) => g.order_category)
        .map((value, key) => ({
          order_category: key,
          data: value,
          total: totalConsumption(value),
          discount: discountConsumption(value),
          per_product: totalCostPerProduct(value),
        }))
        .value();
      res.length > 1
        ? parseFloat(res[0].total + res[0].per_product - res[0].discount) >
          parseFloat(res[1].total + res[1].per_product - res[1].discount)
          ? (total = res[0].total + res[0].per_product - res[0].discount)
          : (total = res[1].total + res[1].per_product - res[1].discount)
        : (total = res[0].total + res[0].per_product - res[0].discount);
    } else {
      for (let i = 0; i < data.length; i++) {
        if (data[i].payment_method === "ecash") {
          total +=
            (parseInt(data[i].is_per_piece) === 1
              ? (data[i].quantity !== null ? parseInt(data[i].quantity) : 1) *
                parseFloat(data[i].price)
              : parseFloat(data[i].price) * 1) +
            parseFloat(
              data[i].cost_per_prod !== null
                ? parseInt(data[i].is_per_piece) === 0
                  ? data[i].cost_per_prod
                  : data[i].cost_per_prod * data[i].quantity
                : 0
            ) -
            parseFloat(data[i].discount_amount);
        }
        if (data[i].payment_method === "split-cash") {
          total = parseFloat(data[0].epayment);
        }
      }
    }
    return total;
  };

  const getTotalNonCash = (category, data) => {
    var total = 0;
    if (data[0].noncash === category) {
      total = parseFloat(data[0].epayment);
    }
    return total;
  };

  const getEmployeeList = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
      status: 1,
    };
    axios
      .get("user/merchant/employee-list", { params })
      .then((response) => {
        const data = response.data;
        setEmployeeList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  useEffect(() => {
    getMerchantOrderSaveList();
    getEmployeeList();
  }, [getMerchantOrderSaveList, getEmployeeList]);

  const searchable = merchantOrderSaveList.data.filter((data) => {
    return (
      data.customer_name.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.transaction_id.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleFilter = (values) => {
    var DATEFROM = moment(new Date(values.date_from)).format("YYYY-MM-DD");
    var DATETO = moment(new Date(values.date_to)).format("YYYY-MM-DD");

    var date_from = "";
    var date_to = "";
    if (
      permissionList.data.merchant_info.operation_opens !== null &&
      permissionList.data.merchant_info.operation_closes !== null
    ) {
      if (
        permissionList.data.merchant_info.operation_closes <
        permissionList.data.merchant_info.operation_opens
      ) {
        date_from = moment(
          `${DATEFROM}T${permissionList.data.merchant_info.operation_opens}`
        ).format("YYYY-MM-DDTHH:mm:ss");
        date_to = moment(
          `${DATETO}T${permissionList.data.merchant_info.operation_closes}`
        )
          .add(1, "day")
          .format("YYYY-MM-DDTHH:mm:ss");
      } else {
        date_from = moment(
          `${DATEFROM}T${permissionList.data.merchant_info.operation_opens}`
        ).format("YYYY-MM-DDTHH:mm:ss");
        date_to = moment(
          `${DATETO}T${permissionList.data.merchant_info.operation_closes}`
        ).format("YYYY-MM-DDTHH:mm:ss");
      }
    } else {
      date_from = moment(`${DATEFROM}T00:00:00`).format("YYYY-MM-DDTHH:mm:ss");
      date_to = moment(`${DATETO}T23:59:00`).format("YYYY-MM-DDTHH:mm:ss");
    }

    var params = {
      date_from,
      date_to,
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
      status: 1,
      orderby: "desc",
      employee: values.employee,
    };

    setDateFrom(moment(date_from).format("YYYY-MM-DD HH:mm:ss"));
    setDateTo(moment(date_to).format("YYYY-MM-DD HH:mm:ss"));

    setLoading(true);
    axios
      .get("user/merchant/filter/customer-order-list", { params })
      .then((response) => {
        const data = response.data;
        const perprod = _.chain(data)
          .groupBy((g) => g.product_id)
          .map((value, key) => ({
            product_id: key,
            product: value[0].product,
            total: getPerProdTotal(value),
            per_piece: parseInt(value[0].is_per_piece) === 1 ? true : false,
            order_category: value[0].order_category,
            product_category:
              value[0].customerorderroductinfo !== null
                ? value[0].customerorderroductinfo.productcategory.category
                : null,
          }))
          .value();
        setDataList({ data: perprod, ready: true });
        rerunNotif("success", "Filter successful.");
        setTimeout(() => {
          const res = _.chain(data)
            .groupBy((g) => g.transaction_id)
            .map((value, key) => ({
              transaction_id: key,
              data: _.orderBy(value, ["id"], ["asc"]),
              customer_name: value[0].customer_name,
              created_at: value[0].created_at,
              table_no: value[0].table_no,
              service_category: value[0].service_category,
              cashiered_by:
                value[0].customerordercashiered !== null
                  ? value[0].customerordercashiered.firstname
                  : "",
              cost: getTotalCost(value),
              cost_per_prod: getTotalCostPerProd(
                _.orderBy(value, ["id"], ["asc"])
              ),
              discount: getTotalDiscount(value),
              dine_in: getTotalDineIn(value),
              take_out: getTotalTakeOut(value),
              pick_up: getTotalPickup(value),
              delivery: getTotalDelivery(value),
              cash: getTotalCash(value),
              ecash: getTotalECash(value),

              gcash: getTotalNonCash("gcash", value),
              gcredit: getTotalNonCash("gcredit", value),
              paymaya: getTotalNonCash("paymaya", value),
              creditcard: getTotalNonCash("creditcard", value),
              debitcard: getTotalNonCash("debitcard", value),
              banktransfer: getTotalNonCash("banktransfer", value),
              cheque: getTotalNonCash("cheque", value),
            }))
            .value();
          const res2 = _.orderBy(res, ["created_at"], ["desc"]);
          setMerchantOrderSaveList({ data: res2, ready: true });
          setTotalGross(calculateTotal(res, "gross"));
          setTotalDiscount(calculateTotal(res, "discount"));
          setTotalCostPerProd(calculateTotal(res, "cost_per_prod"));

          setTotalDineIn(calculateTotal(res, "dinein"));
          setTotalTakeOut(calculateTotal(res, "takeout"));
          setTotalPickup(calculateTotal(res, "pickup"));

          setTotalDelivery(calculateTotal(res, "delivery"));
          setTotalCash(calculateTotal(res, "cash"));
          setTotalECash(calculateTotal(res, "ecash"));

          //new
          setTotalGCash(calculateTotal(res, "gcash"));
          setTotalGCredit(calculateTotal(res, "gcredit"));
          setTotalPaymaya(calculateTotal(res, "paymaya"));
          setTotalCreditCard(calculateTotal(res, "creditcard"));
          setTotalDebitCard(calculateTotal(res, "debitcard"));
          setTotalBankTransfer(calculateTotal(res, "banktransfer"));
          setTotalCheque(calculateTotal(res, "cheque"));

          setOpenFilterByDate(false);
          setLoading(false);
          setDetectFilter(true);
        }, 1000);
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoadings(false);
      });
  };

  const calculateTotal = (data, mode) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      if (mode === "gross") {
        total += parseFloat(data[i].cost) * 1;
      }
      if (mode === "discount") {
        total += parseFloat(data[i].discount) * 1;
      }
      if (mode === "cost_per_prod") {
        total += parseFloat(data[i].cost_per_prod) * 1;
      }
      if (mode === "dinein") {
        total += parseFloat(data[i].dine_in) * 1;
      }
      if (mode === "takeout") {
        total += parseFloat(data[i].take_out) * 1;
      }
      if (mode === "pickup") {
        total += parseFloat(data[i].pick_up) * 1;
      }
      if (mode === "delivery") {
        total += parseFloat(data[i].delivery) * 1;
      }
      if (mode === "cash") {
        total += parseFloat(data[i].cash) * 1;
      }
      if (mode === "ecash") {
        total += parseFloat(data[i].ecash) * 1;
      }
      //new
      if (mode === "gcash") {
        total += parseFloat(data[i].gcash) * 1;
      }
      if (mode === "gcredit") {
        total += parseFloat(data[i].gcredit) * 1;
      }
      if (mode === "paymaya") {
        total += parseFloat(data[i].paymaya) * 1;
      }
      if (mode === "creditcard") {
        total += parseFloat(data[i].creditcard) * 1;
      }
      if (mode === "debitcard") {
        total += parseFloat(data[i].debitcard) * 1;
      }
      if (mode === "banktransfer") {
        total += parseFloat(data[i].banktransfer) * 1;
      }
      if (mode === "cheque") {
        total += parseFloat(data[i].cheque) * 1;
      }
    }
    return total;
  };

  const discountConsumption = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseFloat(data[i].discount_amount) * 1;
    }
    return total;
  };

  const totalCostPerProduct = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        parseFloat(data[i].cost_per_prod !== null ? data[i].cost_per_prod : 0) *
        1;
    }
    return total;
  };

  const totalConsumption = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        data[i].service_type === "consumable"
          ? parseFloat(data[i].price) * 1
          : parseFloat(data[i].quantity) * parseFloat(data[i].price);
    }
    return total;
  };

  const exportToExcel = () => {
    const selectedColumns = [
      "transaction_id",
      "customer_name",
      "created_at",
      "table_no",
      "service_category",
      "cashiered_by",
      "cost",
    ]; // Add columns you want to export
    const filteredData = searchable.map((row) => {
      const filteredRow = {};
      selectedColumns.forEach((column) => {
        filteredRow[column] = row[column];
      });
      return filteredRow;
    });

    // const worksheet = XLSX.utils.json_to_sheet(
    //   searchable.length > 0 ? searchable : []
    // );
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "digimenu_report.xlsx");
  };

  return (
    <MerchantEmployeeLayout>
      <div>
        <Typography
          style={{ fontStyle: "italic", color: "blue", fontWeight: "bold" }}
        >
          Note: The default is 1 week record transaction, but you can use filter
          to fetch the desire date range and generate report.
        </Typography>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            width: 10,
            height: 10,
            backgroundColor: "red",
            marginRight: 5,
          }}
        />
        <Typography style={{ fontWeight: "bold" }}>Discounted</Typography>
      </div>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
        <div
          style={{
            width: 10,
            height: 10,
            backgroundColor: "green",
            marginRight: 5,
          }}
        />
        <Typography style={{ fontWeight: "bold" }}>Non-Discounted</Typography>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            id="search"
            placeholder="Search transaction # or name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>

        <Tooltip title="Excel Export">
          <Button
            icon={<ExportOutlined />}
            style={{ marginRight: 5 }}
            onClick={exportToExcel}
          >
            Export
          </Button>
        </Tooltip>

        <Tooltip title="Filter by date">
          <Button
            icon={<CalendarOutlined />}
            style={{ marginRight: 5 }}
            onClick={() => setOpenFilterByDate(true)}
          >
            Filter
          </Button>
        </Tooltip>

        {detectFilter && (
          <Tooltip title="Transaction Report">
            <Button
              onClick={() => {
                setOpenReaderDrawer(true);
              }}
              icon={<QuestionCircleOutlined />}
              disabled={!detectFilter}
              style={{ marginRight: 5 }}
            >
              Transaction Report
            </Button>
          </Tooltip>
        )}

        {detectFilter && (
          <Tooltip title="Product Sold">
            <Button
              onClick={() => {
                setOpenPerProdDrawer(true);
              }}
              icon={<QuestionCircleOutlined />}
              disabled={!detectFilter}
            >
              Product Sold
            </Button>
          </Tooltip>
        )}
      </div>

      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.transaction_id}
          summary={() => (
            <Table.Summary fixed={"bottom"}>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={7} align="right">
                  <p style={{ fontWeight: "bold" }}>
                    Total:{" "}
                    {totalGross.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                </Table.Summary.Cell>
                <Table.Summary.Cell />
              </Table.Summary.Row>
            </Table.Summary>
          )}
        />
      </div>

      {/* REPORT DETAILS  */}
      {openDrawer && (
        <MerchantEmployeeReportOrderDetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          selectedData={selectedData}
        />
      )}

      {/* READING  */}
      {openReaderDrawer && (
        <MerchantReading
          open={openReaderDrawer}
          close={() => setOpenReaderDrawer(false)}
          totalGross={totalGross}
          totalDiscount={totalDiscount}
          totalCostPerProd={totalCostPerProd}
          totalDineIn={totalDineIn}
          totalTakeOut={totalTakeOut}
          totalPickup={totalPickup}
          totalDelivery={totalDelivery}
          totalCash={totalCash}
          totalECash={totalECash}
          //new
          totalGCash={totalGCash}
          totalGCredit={totalGCredit}
          totalPaymaya={totalPaymaya}
          totalCreditCard={totalCreditCard}
          totalDebitCard={totalDebitCard}
          totalBankTransfer={totalBankTransfer}
          totalCheque={totalCheque}
          //
          data={merchantOrderSaveList}
          dateFrom={dateFrom}
          dateTo={dateTo}
          perproductcost={userData.data.usersmerchantemployee.perproductcost}
        />
      )}

      {/* REPORT PER PRODUCT  */}
      {openPerProdDrawer && (
        <MerchantReportPerProduct
          open={openPerProdDrawer}
          close={() => setOpenPerProdDrawer(false)}
          data={dataList}
          dateFrom={dateFrom}
          dateTo={dateTo}
        />
      )}

      {/* FILTER BY DATE & EMPLOYEE */}
      <Modal
        title=""
        open={openFilterByDate}
        onCancel={() => setOpenFilterByDate(false)}
        footer={null}
        width={350}
        centered
      >
        <Form
          layout="vertical"
          name="report-filter"
          initialValues={{ employee: "all" }}
          onFinish={handleFilter}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="date_from"
              label="Date From"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="date_to"
              label="Date To"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="employee"
              label="Employee"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select placeholder="Select employee" size="large">
                <Select.Option value={"all"}>All</Select.Option>
                {employeeList.data.length > 0 &&
                  employeeList.data.map((data, index) => (
                    <Select.Option value={data.user_id} key={index}>
                      {data.firstname} {data.lastname}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Filter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </MerchantEmployeeLayout>
  );
};

export default MerchantEmployeeAccountingReports;
